export { default as Modal } from './Modal';
export { default as ModalBackground } from './ModalBackground';
export { default as ModalContent } from './ModalContent';
export { default as ModalClose } from './ModalClose';

export {
    Card as ModalCard,
    Header as ModalCardHeader,
    Title as ModalCardTitle,
    Body as ModalCardBody,
    Footer as ModalCardFooter,
} from './Card';


// WEBPACK FOOTER //
// ./src/components/Modal/index.ts